import * as actionTypes from './actionTypes';

import { v4 } from "uuid";

export const toggleLayerLeftSidebar = (value, skep) => {
    return {
        type: actionTypes.LAYERLEFTSIDEBAR_TOGGLE,
        value: value,
        skep: skep
    };
};

export const skepTempCustomLayerInit = () => {
    return {
        type: actionTypes.SKEP_TEMP_CUSTOM_LAYER_INIT
    };
};

export const skepTempCustomLayer = (datalayer, layer, version, drawingManager) => {
    return {
        type: actionTypes.SKEP_TEMP_CUSTOM_LAYER,
        datalayer: datalayer,
        layer: layer,
        version: version,
        drawingManager: drawingManager
    };
};

export const toggleFeatureInfoBox = (open, coordinates, feature, google) => {
    return {
        type: actionTypes.TOGGLE_FEATURE_INFOBOX,
        open: open,
        coordinates: coordinates,
        feature: feature,
        google: google
    };
}

export const editTempCustomLayer = (value, datalayer) => {
    let id = v4();
    let properties = {};
    if (value?.getType() === "Point") {
        properties = {
            strokeColor: "#000",
            strokeWeight: 1,
            strokeOpacity: 1,
            fillColor: "#fff",
            fillOpacity: 1,
            iconPath: "M12,2C8.13,2,5,5.13,5,9C5,14.25,12,22,12,22S19,14.25,19,9C19,5.13,15.87,2,12,2zM12,11.5C10.62,11.5,9.5,10.38,9.5,9S10.62,6.5,12,6.5S14.5,7.62,14.5,9S13.38,11.5,12,11.5z"
        };
    } else if (value?.getType() === "Polygon") {
        properties = {
            strokeColor: "#000",
            strokeWeight: 1,
            strokeOpacity: 1,
            fillColor: "#000",
            fillOpacity: 0.3,
        };
    } else if (value?.getType() === "LineString") {
        properties = {
            strokeColor: "#000",
            strokeWeight: 1,
            strokeOpacity: 1,
        };
    }
    let nuwefeature = {
        "type": "Feature",
        "properties": {
            ...properties,
            id: id
        },
        "geometry": value
    };

    datalayer.add(nuwefeature);
    datalayer.setStyle(feature => {
        let icon = {};
        if (feature.getGeometry()?.getType() === "Point") {
            icon = {
                icon: {
                    path: feature.getProperty("iconPath"),
                    fillColor: feature.getProperty("fillColor"),
                    fillOpacity: feature.getProperty("fillOpacity"),
                    strokeColor: feature.getProperty("strokeColor"),
                    strokeWeight: feature.getProperty("strokeWeight"),
                    strokeOpacity: feature.getProperty("strokeOpacity"),
                    anchor: new window.google.maps.Point(12, 24),
                    scale: 1.5
                }
            };
        }
        return {
            strokeColor: feature.getProperty("strokeColor"),
            strokeWeight: feature.getProperty("strokeWeight"),
            strokeOpacity: feature.getProperty("strokeOpacity"),
            fillColor: feature.getProperty("fillColor"),
            fillOpacity: feature.getProperty("fillOpacity"),
            ...icon,
            zIndex: 9999,
            editable: true,
            draggable: true,
            clickable: true
        };
    });

    return {
        type: actionTypes.EDIT_TEMP_CUSTOM_LAYER,
        datalayer: datalayer,
        id: id
    };
};

export const editTempCustomLayerKanselleer = (datalayer) => {
    return {
        type: actionTypes.EDIT_TEMP_CUSTOM_LAYER_KANSELLEER,
        datalayer: datalayer
    };
};

export const onCustomLayerStoor = (datalayer) => {
    return {
        type: actionTypes.ON_CUSTOM_LAYER_STOOR,
        datalayer: datalayer
    };
};

export const onCustomLayerStoorLoading = () => {
    return {
        type: actionTypes.ON_CUSTOM_LAYER_STOOR_LOADING
    };
};

export const onCustomLayerStoorSuccess = () => {
    return {
        type: actionTypes.ON_CUSTOM_LAYER_STOOR_SUCCESS
    };
};

export const onCustomLayerStoorFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.ON_CUSTOM_LAYER_STOOR_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const editTempCustomLayerError = (value) => {
    return {
        type: actionTypes.EDIT_TEMP_CUSTOM_LAYER_ERROR,
        value: value
    };
};

export const validateTempCustomLayer = (value, datalayer) => {
    return {
        type: actionTypes.EDIT_TEMP_CUSTOM_LAYER_VALIDATE,
        value: value,
        datalayer: datalayer
    };
};

export const verwyderFeature = (datalayer, feature, id) => {
    datalayer.remove(feature);
    return {
        type: actionTypes.VERWYDER_FEATURE,
        feature: feature,
        id: id
    };
}

export const editFeatureProperty = (feature, property, value, id, datalayer) => {
    feature.setProperty(property, value);
    datalayer.setStyle(feature => {
        let icon = {};
        if (feature.getGeometry()?.getType() === "Point") {
            icon = {
                icon: {
                    path: feature.getProperty("iconPath"),
                    fillColor: feature.getProperty("fillColor"),
                    fillOpacity: feature.getProperty("fillOpacity"),
                    strokeColor: feature.getProperty("strokeColor"),
                    strokeWeight: feature.getProperty("strokeWeight"),
                    strokeOpacity: feature.getProperty("strokeOpacity"),
                    anchor: new window.google.maps.Point(12, 24),
                    scale: 1.5
                }
            };
        }
        return {
            strokeColor: feature.getProperty("strokeColor"),
            strokeWeight: feature.getProperty("strokeWeight"),
            strokeOpacity: feature.getProperty("strokeOpacity"),
            fillColor: feature.getProperty("fillColor"),
            fillOpacity: feature.getProperty("fillOpacity"),
            ...icon,
            zIndex: 9999,
            editable: true,
            draggable: true,
            clickable: true
        };
    });

    return {
        type: actionTypes.EDIT_FEATURE_PROPERTY,
        id: id,
        feature: feature,
        datalayer: datalayer
    };
}

export const skepCustomLayer = (body, datalayer) => {
    return {
        type: actionTypes.SKEP_CUSTOM_LAYER,
        body: body,
        datalayer: datalayer
    };
};

export const skepCustomLayerLoading = () => {
    return {
        type: actionTypes.SKEP_CUSTOM_LAYER_LOADING
    };
};

export const skepCustomLayerSuccess = (data) => {
    return {
        type: actionTypes.SKEP_CUSTOM_LAYER_SUCCESS,
        data: data
    };
};

export const skepCustomLayerFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.SKEP_CUSTOM_LAYER_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const skepCustomLayerClearnotification = () => {
    return {
        type: actionTypes.SKEP_CUSTOM_LAYER_CLEARNOTIFICATION
    };
};

export const skepCustomLayerTelling = (telling) => {
    return {
        type: actionTypes.SKEP_CUSTOM_LAYER_TELLING,
        telling: telling
    };
};

export const skepCustomLayerClose = (datalayer) => {
    return {
        type: actionTypes.SKEP_CUSTOM_LAYER_CLOSE,
        datalayer: datalayer
    };
};

export const stoorCustomLayer = (datalayer, nuweversion, naam) => {
    return {
        type: actionTypes.STOOR_CUSTOM_LAYER,
        datalayer: datalayer,
        nuweversion: nuweversion,
        naam: naam
    };
};

export const stoorCustomLayerLoading = () => {
    return {
        type: actionTypes.STOOR_CUSTOM_LAYER_LOADING
    };
};

export const stoorCustomLayerSuccessMessage = () => {
    return {
        type: actionTypes.STOOR_CUSTOM_LAYER_SUCCESS_MESSAGE
    };
};

export const stoorCustomLayerSuccess = (data) => {
    return {
        type: actionTypes.STOOR_CUSTOM_LAYER_SUCCESS,
        data: data
    };
};

export const stoorNuweVersionCustomLayerSuccess = (data) => {
    return {
        type: actionTypes.STOOR_NUWE_CUSTOM_LAYER_SUCCESS
    };
};

export const stoorCustomLayerFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.STOOR_CUSTOM_LAYER_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const stoorCustomLayerClearnotification = () => {
    return {
        type: actionTypes.STOOR_CUSTOM_LAYER_CLEARNOTIFICATION
    };
};

export const initKryLayerslys_custom = () => {
    return {
        type: actionTypes.INIT_LAYERSLYS_CUSTOM
    };
};

export const getLayerslys_custom = (data) => {
    return {
        type: actionTypes.GET_LAYERSLYS_CUSTOM,
        data: data
    };
};

export const setLayerslys_custom = (data) => {
    return {
        type: actionTypes.SET_LAYERSLYS_CUSTOM,
        data: data
    };
};

export const getLayerslysFailed_custom = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_LAYERSLYS_FAILED_CUSTOM,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const toggleLayerDropdown_custom = (key) => {
    return {
        type: actionTypes.LAYER_TOGGLE_CUSTOM,
        key: key
    };
};

export const kiesLayer_custom = (key) => {
    return {
        type: actionTypes.KIES_LAYER_CUSTOM,
        key: key
    };
};

export const kiesLayerVersion_custom = (key, version) => {
    return {
        type: actionTypes.KIES_LAYER_VERSION_CUSTOM,
        key: key,
        version: version
    };
};

export const setLayerVersion_custom = (data) => {
    data.datalayer.setStyle(feature => {
        let icon = {};
        if (feature?.getGeometry()?.getType() === "Point") {
            icon = {
                icon: {
                    path: feature.getProperty("iconPath") || "M12,2C8.13,2,5,5.13,5,9C5,14.25,12,22,12,22S19,14.25,19,9C19,5.13,15.87,2,12,2zM12,11.5C10.62,11.5,9.5,10.38,9.5,9S10.62,6.5,12,6.5S14.5,7.62,14.5,9S13.38,11.5,12,11.5z",
                    fillColor: feature.getProperty("fillColor"),
                    fillOpacity: feature.getProperty("fillOpacity"),
                    strokeColor: feature.getProperty("strokeColor"),
                    strokeWeight: feature.getProperty("strokeWeight"),
                    strokeOpacity: feature.getProperty("strokeOpacity"),
                    anchor: new window.google.maps.Point(12, 24),
                    scale: 1.5
                }
            };
        }
        return {
            strokeColor: feature.getProperty("strokeColor"),
            strokeWeight: feature.getProperty("strokeWeight"),
            strokeOpacity: feature.getProperty("strokeOpacity"),
            fillColor: feature.getProperty("fillColor"),
            fillOpacity: feature.getProperty("fillOpacity"),
            ...icon,
            zIndex: 9998,
            clickable: true
        };
    });

    return {
        type: actionTypes.SET_LAYERSAKTIEF_VERSION_CUSTOM,
        layer: data.id,
        datalayer: data.datalayer,
        version: data.version,
        data: data.data,
        len: data.len
    };
};

export const removeLayerVersion_custom = (datalayer, key, version) => {
    return {
        type: actionTypes.REMOVE_LAYER_VERSOIN_CUSTOM,
        key: key,
        version: version,
        datalayer: datalayer
    };
};

export const initKryLayers_custom = () => {
    return {
        type: actionTypes.INIT_LAYERSAKTIEF_CUSTOM
    };
};

export const getLayers_custom = (data) => {
    return {
        type: actionTypes.GET_LAYERSAKTIEF_CUSTOM,
        data: data
    };
};

export const getLayersFailed_custom = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_LAYERSAKTIEF_FAILED_CUSTOM,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const removeLayer_custom = (key, datalayer) => {
    if (datalayer) {
        datalayer.forEach((feature) => {
            datalayer.remove(feature);
        });
    }
    return {
        type: actionTypes.REMOVE_LAYER_CUSTOM,
        key: key
    };
};

export const makeVersionEditable_custom = (layer, version, datalayer) => {
    return {
        type: actionTypes.MAKE_LAYER_EDITABLE_CUSTOM,
        layer: layer,
        version: version,
        datalayer: datalayer
    };
};

export const setMakeVersionEditable_custom = (layer, version, datalayer, data, drawingManager) => {
    return {
        type: actionTypes.SET_MAKE_LAYER_EDITABLE_CUSTOM,
        layer: layer,
        version: version,
        datalayer: datalayer,
        drawingManager: drawingManager
    };
};

export const showFeatureInfoBox = (google, layer, version, afdeling) => {
    return {
        type: actionTypes.SHOW_FEATURE_INFOBOX,
        google: google,
        layer: layer,
        version: version,
        afdeling: afdeling
    };
};

export const closeFeatureInfoBox = (id, layer, version) => {
    return {
        type: actionTypes.CLOSE_FEATURE_INFOBOX,
        id: id,
        layer: layer,
        version: version
    };
};

export const setLayerEventListener_custom = () => {
    return (getState) => {
        var data = [];
        const newlayersmetadata = [getState().layersmetadata.data];
        for (var layer of newlayersmetadata) {
            for (var tipe of layer.layertipes) {
                if (tipe.active && tipe.infooverlay) {
                    if (getState().layers.data.find(obj => obj.id === layer.key)) {
                        data.push(getState().layer.data);
                    }
                }
            }
        }
        return {
            type: actionTypes.SET_LAYER_EVENTLISTENER_CUSTOM,
            data: data
        };
    }
};

export const bindEventlistener_custom = (mustbind) => {
    return {
        type: actionTypes.BIND_EVENTLISTENER_CUSTOM,
        mustbind: mustbind
    };
};

export const bindComponent_custom = () => {
    return {
        type: actionTypes.BIND_COMPONENT_CUSTOM
    };
};

export const deleteCustomLayerVersion = (datalayer) => {
    return {
        type: actionTypes.DELETE_CUSTOM_LAYER_VERSION,
        datalayer: datalayer
    };
};

export const deleteCustomLayerVersionLoading = () => {
    return {
        type: actionTypes.DELETE_CUSTOM_LAYER_VERSION_LOADING
    };
};

export const deleteCustomLayerVersionSuccessMessage = () => {
    return {
        type: actionTypes.DELETE_CUSTOM_LAYER_VERSION_SUCCESS_MESSAGE
    };
};

export const deleteCustomLayerVersionSuccess = (data) => {
    return {
        type: actionTypes.DELETE_CUSTOM_LAYER_VERSION_SUCCESS
    };
};

export const deleteCustomLayerVersionFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.DELETE_CUSTOM_LAYER_VERSION_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const setLayerNaamEdit = (layer) => {
    return {
        type: actionTypes.SET_CHANGE_LAYER_NAME,
        layer: layer
    };
};

export const stoorCustomLayerName = (layer, naam) => {
    return {
        type: actionTypes.CHANGE_LAYER_NAME,
        layer: layer,
        naam: naam
    };
};

export const stoorCustomLayerNameLoading = () => {
    return {
        type: actionTypes.CHANGE_LAYER_NAME_LOADING
    };
};

export const stoorCustomLayerNameSuccessMessage = () => {
    return {
        type: actionTypes.CHANGE_LAYER_NAME_SUCCESS_MESSAGE
    };
};

export const stoorCustomLayerNameSuccess = (data) => {
    return {
        type: actionTypes.CHANGE_LAYER_NAME_SUCCESS,
        data: data
    };
};

export const stoorCustomLayerNameFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.CHANGE_LAYER_NAME_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const addCustomLayerLog = (log) => {
    return {
        type: actionTypes.ADD_CUSTOM_LAYER_LOG,
        log: log
    };
};

export const clearCustomLayerLogs = () => {
    return {
        type: actionTypes.CLEAR_CUSTOM_LAYER_LOGS
    };
};

export const searchIcons_CustomLayers = (phrase) => {
    return {
        type: actionTypes.SEARCH_ICONS_CL,
        phrase: phrase
    };
};

export const getIcons_CustomLayers = () => {
    return {
        type: actionTypes.GET_ICONS_CL
    };
};

export const setIcons_CustomLayers = (data) => {
    return {
        type: actionTypes.SET_ICONS_CL,
        data: data
    };
};

export const getIconsFailed_CustomLayers = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_ICONS_FAILED_CL,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const addFeaturesProgram_CustomLayers = (value, datalayer, type) => {
    let properties = {
        strokeColor: "#000",
        strokeWeight: 1,
        strokeOpacity: 1,
        fillColor: "#000",
        fillOpacity: 0.3,
    };
    if (type === "Point") {
        properties = {
            ...properties,
            iconPath: "M12,2C8.13,2,5,5.13,5,9C5,14.25,12,22,12,22S19,14.25,19,9C19,5.13,15.87,2,12,2zM12,11.5C10.62,11.5,9.5,10.38,9.5,9S10.62,6.5,12,6.5S14.5,7.62,14.5,9S13.38,11.5,12,11.5z"
        };
        let values = value.split(";").map(item => item.replace("\n", "")).filter(item => parseFloat(item));

        values.forEach(val => {
            let value = val.split(",").map(item => parseFloat(item));
            let nuwefeature = {
                "type": "Feature",
                "properties": {
                    ...properties,
                    id: v4()
                },
                "geometry": {
                    type: type,
                    coordinates: [value[1], value[0]]
                }
            };

            datalayer.addGeoJson(nuwefeature, { idPropertyName: 'id' });
        });
    } else {
        let id = v4();
        let coordinates = [];
        let values = value.split(";").map(item => item.replace("\n", "")).filter(item => parseFloat(item));
        values.forEach(val => {
            let value = val.split(",").map(item => parseFloat(item));
            coordinates.push([value[1], value[0]]);
        });

        if (type === "Polygon") {
            if (coordinates[0] !== coordinates[coordinates.length - 1]) {
                coordinates.push(coordinates[0]);
            }
            coordinates = [coordinates];
        }
        let nuwefeature = {
            "type": "Feature",
            "properties": {
                ...properties,
                id: id
            },
            "geometry": {
                type: type,
                coordinates: coordinates
            }
        };

        datalayer.addGeoJson(nuwefeature, { idPropertyName: 'id' });
    }

    datalayer.setStyle(feature => {
        let icon = {};
        if (feature.getGeometry()?.getType() === "Point") {
            icon = {
                icon: {
                    path: feature.getProperty("iconPath"),
                    fillColor: feature.getProperty("fillColor"),
                    fillOpacity: feature.getProperty("fillOpacity"),
                    strokeColor: feature.getProperty("strokeColor"),
                    strokeWeight: feature.getProperty("strokeWeight"),
                    strokeOpacity: feature.getProperty("strokeOpacity"),
                    anchor: new window.google.maps.Point(12, 24),
                    scale: 1.5
                }
            };
        }
        return {
            strokeColor: feature.getProperty("strokeColor"),
            strokeWeight: feature.getProperty("strokeWeight"),
            strokeOpacity: feature.getProperty("strokeOpacity"),
            fillColor: feature.getProperty("fillColor"),
            fillOpacity: feature.getProperty("fillOpacity"),
            ...icon,
            zIndex: 9999,
            editable: true,
            draggable: true,
            clickable: true
        };
    });

    return {
        type: actionTypes.ADD_FEATURES_PROGR_CUSTOM_LAYER,
        datalayer: datalayer
    };
};

export const setDrawingMode_CustomLayers = (mode) => {
    return {
        type: actionTypes.SET_DRAWINGMODE_CUSTOM_LAYER,
        mode: mode
    };
};

export const saveTemplaatIcon_CustomLayers = (style) => {
    return {
        type: actionTypes.SAVE_TEMPLAATICON_CUSTOM_LAYER,
        style: style
    };
};

export const gebruikTemplaatIcon_CustomLayers = (style, feature) => {
    return {
        type: actionTypes.GEBRUIK_TEMPLAATICON_CUSTOM_LAYER,
        style: style,
        feature: feature
    };
};

export const kiesTemplaatIcon_CustomLayers = (style) => {
    return {
        type: actionTypes.KIES_TEMPLAATICON_CUSTOM_LAYER,
        style: style
    };
};

export const stelKoordinate_CustomLayers = (feature, value, id) => {
    console.log(feature, feature.getGeometry());
    let type = feature.getGeometry().getType();
    let coordinates = [];

    let values = value.split(";").map(item => item.replace("\n", "")).filter(item => parseFloat(item));
    values.forEach(val => {
        let value = val.split(",").map(item => parseFloat(item));
        coordinates.push(new window.google.maps.LatLng(value[0], value[1]));
    });

    if (type === "Point") {
        coordinates = coordinates[0];
    } else if (type === "Polygon") {
        if (coordinates[0] !== coordinates[coordinates.length - 1]) {
            coordinates.push(coordinates[0]);
        }
    }

    console.log({
        type: type,
        coordinates: coordinates
    })
    feature.setGeometry(coordinates);

    return {
        type: actionTypes.STEL_KOORDINATE_CUSTOM_LAYER,
        id: id
    };
};